// extracted by mini-css-extract-plugin
module.exports = {"deliverySettingsForm":"delivery-settings-form_deliverySettingsForm__1Abcu","mt20":"delivery-settings-form_mt20__3Jo0k","warning":"delivery-settings-form_warning__dKejy"};